import gsap from 'gsap'
import CustomEase from 'gsap/CustomEase'
import MorphSVGPlugin from 'gsap/MorphSVGPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import Draggable from 'gsap/Draggable'
import InertiaPlugin from 'gsap/InertiaPlugin'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import SplitText from 'gsap/SplitText'

export type GSAP = typeof gsap

export type InitGSAPOptions = {
  extraPlugins?: gsap.Plugin[]
  reduceMotion?: boolean
}

let initialized = false

export function initGSAP(options: InitGSAPOptions = {}) {
  if (initialized) {
    console.warn(
      'initGSAP() was called more than once. Only the first call takes effect; subsequent options are ignored.'
    )
    return
  }
  initialized = true

  try {
    gsap.registerPlugin(
      Draggable,
      InertiaPlugin,
      ScrollToPlugin,
      ScrollTrigger,
      DrawSVGPlugin,
      MorphSVGPlugin,
      CustomEase,
      SplitText,
      ...(options.extraPlugins ?? [])
    )

    CustomEase.create(
      'summaryLineY',
      'M0 81C209.946 81 277.228 -32.1838 386.904 14.6203C608.442 109.161 710.4 37.0767 837.209 14.6203C1137.32 -38.5251 1213.31 81 1440 80.9999C1649.95 80.9999 1717.23 -32.1838 1826.9 14.6203C2048.44 109.161 2150.4 37.0767 2277.21 14.6203C2577.32 -38.5251 2653.31 81 2880 80.9999'
    )
    CustomEase.create('powerInBackOut', 'M0,0 C0.564,0 0.489,1.028 0.725,1.077 0.859,1.105 0.846,1 1,1 ')
    CustomEase.create('blinkEye1', 'M0,0 C0.497,0.207 0.498,0.2 1,0 ')
    CustomEase.create('blinkEye2', 'M0,0 C0.5,0.406 0.5,0.406 1,0 ')

    if (options.reduceMotion) {
      const mm = gsap.matchMedia()
      mm.add('(prefers-reduced-motion: reduce)', () => {
        gsap.globalTimeline.timeScale(1000)
      })
    }
  } catch (e) {
    initialized = false
    throw e
  }
}

export function useGSAP(): {
  gsap: GSAP
  Draggable: typeof Draggable
  SplitText: typeof SplitText
} {
  return {
    gsap,
    Draggable,
    SplitText,
  }
}
